import React, { useState, useEffect } from "react";
import "./App.css";

import PostProjectButton from "./PostProjectButton";
import DynamicForm from "./DynamicForm";
import FormNames from "./FormName";
import {
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  Text,
  useDisclosure,
} from "@chakra-ui/react";
import zoluteLogo from "../src/Zolute.png";
import projectImage from "../src/img.jpg";
import UserDataForm from "./UserData";
// import { FaPhone } from 'react-icons/fa';
import CallbackForm from "./CallbackForm";
import { HiPhone } from "react-icons/hi";

// import axios from 'axios';

const LandingPage = () => {
  const [isFormVisible, setFormVisible] = useState(false);
  const [activeForm, setActiveForm] = useState(null);
  const [completedForms, setCompletedForms] = useState([]);
  const [formData, setFormData] = useState(null);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [showThankYou, setShowThankYou] = useState(false);
  const [isMenuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const FormData = {
      InitialForm: "A",
      forms: [
        {
          id: "A",
          name: "Project Details",
          sections: [
            {
              name: "Type",
              position: 0,
              fields: [
                {
                  id: "1",
                  name: "project_type",
                  position: 0,
                  label: "I have",
                  type: "RADIO",
                  options: [
                    "New Project Development",
                    "Existing project",
                  ],
                  default: "New Project Development",
                  required: true,
                },
                {
                  id: "2",
                  name: "request_type",
                  position: 1,
                  label: "I want",
                  type: "RADIO",
                  options: ["Development Quotation", "To Hire resources"],
                  default: "Development Quotation",
                  required: true,
                },
              ],
            },
          ],
          navigationConditions: [
            {
              rules: {
                AND: [
                  {
                    fieldid: "2",
                    condition: "eq",
                    value: "Development Quotation",
                  },
                ],
              },
              nextForm: "B",
            },
            {
              rules: {
                AND: [
                  {
                    fieldid: "2",
                    condition: "eq",
                    value: "To Hire resources",
                  },
                ],
              },
              nextForm: "F",
            },
          ],
        },
        {
          id: "B",
          name: "Project Requirement",
          sections: [
            {
              name: "Requirement",
              position: 0,
              fields: [
                {
                  id: "3",
                  name: "requirementDescription",
                  position: 0,
                  label: "Write a brief description about your project & requirement",
                  type: "TEXTAREA",
                  default: "Yes",
                  required: false,
                },
                {
                  id: "4",
                  name: "hasRequirementDocuments",
                  position: 1,
                  label: "Do you have requirement documents?",
                  type: "RADIO",
                  options: ["Yes", "No"],
                  default: "Yes",
                  required: true,
                },
              ],
            },
          ],
          navigationConditions: [
            {
              rules: {
                AND: [
                  {
                    fieldid: "4",
                    condition: "eq",
                    value: "Yes",
                  },
                ],
              },
              nextForm: "C",
            },
            {
              rules: {
                AND: [
                  {
                    fieldid: "4",
                    condition: "eq",
                    value: "No",
                  },
                ],
              },
              nextForm: "D",
            },
          ],
        },
        {
          id: "C",
          name: "Requirement Details",
          sections: [
            {
              name: "Technical",
              position: 0,
              fields: [
                {
                  id: "5",
                  name: "requirementDoc",
                  position: 0,
                  label: "Please upload scope of work / requirement details",
                  type: "FILE",
                  default: "No",
                  required: false,
                },
              ],
            },
            {
              name: "UI",
              position: 1,
              fields: [
                {
                  id: "6",
                  name: "isUITemplateAvailable",
                  position: 1,
                  label:
                    "Do you have UI / Wireframe Available?",
                  type: "RADIO",
                  options: [
                    "Yes",
                    "No",
                    "N/A",
                  ],
                  default: "Yes",
                  required: true,
                },
                {
                  id: "7",
                  name: "figmaURL",
                  position: 2,
                  label: "Please share figma / wireframe . Mockup  url  (if any )",
                  type: "TEXTFIELD",
                  default: "",
                  required: false,
                },
              ],
            },
          ],
          navigationConditions: [
            {
              rules: {
                AND: [
                ],
              },
              nextForm: "D",
            },
          ],
        },
        {
          id: "D",
          name: "Estimations",
          sections: [
            {
              name: "Timeline",
              position: 0,
              fields: [
                {
                  id: "8",
                  name: "expectedCompletionTime",
                  position: 0,
                  label: "I expect the project to be completed within",
                  type: "RADIO",
                  options: ["Less than 1 Month", "1-3 Months", "More than 3 Months"],
                  default: "1-3 Months",
                  required: true,
                },
              ],
            },
            {
              name: "Cost",
              position: 1,
              fields: [
                {
                  id: "9",
                  name: "budgetEstimate",
                  position: 1,
                  label: "I have a budget of",
                  type: "RADIO",
                  options: ["Below 10K USD", "10K-50K USD", "Above 50K USD"],
                  default: "Above 50K USD",
                  required: true,
                },
              ],
            },
          ],
        },
        {
          id: "E",
          name: "Technical Specification",
          sections: [
            {
              name: "Technical Info",
              position: 0,
              fields: [
                {
                  id: "10",
                  name: "applicationType",
                  position: 0,
                  label: "It is a",
                  type: "RADIO",
                  options: ["Web Application", "Mobile Application", "Hybrid", "Desktop", "Other"],
                  default: "",
                  required: true,
                },
                {
                  id: "11",
                  name: "technologyStack",
                  position: 1,
                  label: "We are using following technology stack",
                  type: "MULTISELECT TAG",
                  options: ["React", "Vue", "Angular", "Node.js", "Python", "Java"],
                  default: [],
                  required: true,
                },
              ],
            },
          ],
          navigationConditions: [
            {
              rules: {
                AND: [
                ],
              },
              nextForm: "C",
            },
          ],
        },
        {
          id: "F",
          name: "Resource Details",
          sections: [
            {
              name: "Project Info",
              position: 0,
              fields: [
                {
                  id: "12",
                  name: "projectBriefing",
                  position: 0,
                  label: "Please share brief detail about your project",
                  type: "TEXTAREA",
                  default: "No",
                  required: true,
                },
              ],
            },
            {
              name: "Team Info",
              position: 1,
              fields: [
                {
                  id: "13",
                  name: "requiredSkills",
                  position: 1,
                  label:
                    "Enter Skills you require in resource",
                  type: "MULTISELECT TAG",
                  options: ["JavaScript", "Python", "Java", "C#", "Ruby", "PHP"],
                  default: [],
                  required: true,
                },
                {
                  id: "14",
                  name: "teamSize",
                  position: 2,
                  label: "Team Size",
                  type: "DROPDOWN",
                  options: ["1", "2", "3", "4", "5", "Above"],
                  default: "1",
                  required: true,
                },
                {
                  id: "15",
                  name: "experience",
                  position: 3,
                  label: "Experience",
                  type: "RADIO",
                  options: ["Fresher", "Intermediate", "Expert"],
                  default: "Intermediate",
                  required: false,
                },
              ],
            },
          ],
          navigationConditions: [
            {
              rules: {
                AND: [
                ],
              },
              nextForm: "G",
            },
          ],
        },
        {
          id: "G",
          name: "Job Details",
          sections: [
            {
              name: "Time Zone",
              position: 0,
              fields: [
                {
                  id: "16",
                  name: "timezone",
                  position: 0,
                  label: "I want the team to work in the following timezone",
                  type: "TIMEZONE",
                  options: ["All timezone"],
                  default: "ASIA/ABUDHABI",
                  required: true,
                },
              ],
            },
            {
              name: "Job Description",
              position: 1,
              fields: [
                {
                  id: "17",
                  name: "jobDescription",
                  position: 1,
                  label:
                    "Upload Job Description (if available)",
                  type: "FILE",
                  default: "Yes",
                  required: false,
                },
                {
                  id: "18",
                  name: "englishFluency",
                  position: 2,
                  label: "English Fluency",
                  type: "RADIO",
                  options: ["Beginner", "Intermediate", "Advanced", "Proficient"],
                  default: "Intermediate",
                  required: false,
                },
              ],
            },
          ],
          navigationConditions: [
            {
              rules: {
                AND: [
                ],
              },
              nextForm: "H",
            },
          ],
        },
        {
          id: "H",
          name: "Contract Details",
          sections: [
            {
              name: "Contract Info",
              position: 0,
              fields: [
                {
                  id: "19",
                  name: "contractLocation",
                  position: 0,
                  label: "I want my team to work ",
                  type: "RADIO",
                  options: [
                    "Remote",
                    "On Premise",
                    "Hybrid"
                  ],
                  default: "Remote",
                  required: true,
                },
                {
                  id: "20",
                  name: "hiringTerms",
                  position: 1,
                  label: "I want my team to be hired as",
                  type: "RADIO",
                  options: ["On Contract", "On Demand"],
                  default: "On Contract",
                  required: true,
                },
                {
                  id: "21",
                  name: "hiringDuration",
                  position: 2,
                  label: "I want the team for",
                  type: "RADIO",
                  options: ["Less than 6 Months", "1 Year", "More than 1 year"],
                  default: "1 Year",
                  required: true,
                },
                {
                  id: "22",
                  name: "hiringUrgency",
                  position: 3,
                  label: "I want the team be hired",
                  type: "RADIO",
                  options: ["Less than 1 Month", "1 Month", "1-3 Months"],
                  default: "Less than 1 Month",
                  required: true,
                },
              ],
            },
          ],
          navigationConditions: [
            {
              rules: {
                AND: [
                ],
              },
              nextForm: "J",
            },
          ],
        },
        {
          id: "J",
          name: "Contract Estimations",
          sections: [
            {
              name: "Estimated Budget",
              position: 0,
              fields: [
                {
                  id: "23",
                  name: "resourceBudget",
                  position: 0,
                  label: "My monthly budget (in USD) for the team is",
                  type: "RADIO",
                  options: ["Below 10K USD", "10K-50K USD", "Above 50K USD"],
                  default: "Above 50K USD",
                  required: false,
                },
                
              ],
            },
          ],
        },
      ],
    };

    setFormData(FormData);
    setActiveForm(FormData.forms[0]?.id);
  }, []);

  useEffect(() => {
    if (formData) {
      console.log("formdata", formData);

      const formArray = formData?.forms;
      setActiveForm(formArray[0].name);
    }
  }, [formData]);

  // useEffect(() => {
  //   const fetchFormData = async () => {
  //     try {
  //       const response = await axios.get('https://erp.zolute.co/api/forms');
  //       // console.log('API Response:', response.data);
  //       const formArray = response.data.data[0]?.forms;
  //       if (formArray && formArray.length > 0) {
  //         setFormData(response.data.data[0]);
  //         setActiveForm(formArray[0].name);
  //         // console.log('Forms found:', formArray);
  //       } else {
  //         console.error('Error: No forms found in the response data');
  //       }
  //     } catch (error) {
  //       console.error('Error fetching form data:', error);
  //     }
  //   };

  //   fetchFormData();
  // }, []);

  useEffect(() => {
    console.log("visibleform", isFormVisible);
  }, [isFormVisible]);

  const handleButtonClick = () => {
    setFormVisible(true);
    // setActiveForm(formData.forms[0]?.name);
  };

  const handleFormSubmit = () => {
    // Simulate form submission success
    setShowThankYou(true);
  };

  const completeForm = (formName) => {
    setCompletedForms((prevCompletedForms) => {
      if (!prevCompletedForms.includes(formName)) {
        return [...prevCompletedForms, formName];
      }
      return prevCompletedForms;
    });
  };

  const handleFormSubmission = () => {
    setFormSubmitted(true);
    setFormVisible(false);
  };

  const toggleMenu = () => {
    setMenuOpen(!isMenuOpen);
  };

  return (
    <div>
      <nav className="navbar">
        <div className="logo-div">
        {/* <a href="https://www.zolute.consulting/" target="_blank" rel="noopener noreferrer" className="zolute-logo"> */}
            <img src={zoluteLogo} alt="Zolute Logo" className="zolute-logo" />
        {/* </a> */}
        </div>

        <div className="nav-links">
          <div className="call">
            {/* <FaPhone className="phone-icon" /> */}
            <HiPhone className="phone-icon" />
            <a href="tel:+971544961587">
              <span>Call +971 5 44961587</span>
            </a>
          </div>
          <div className="callback-div">
            <Button className="callback-button" onClick={onOpen}>
              REQUEST A CALLBACK
            </Button>
            <Button className="callback-button-mobile" onClick={onOpen}>
              CALLBACK
            </Button>
          </div>
          <Button className="menu-button" onClick={toggleMenu}>
            ≡
          </Button>
        </div>
      </nav>

      <hr className="divider" />

      <div className={`mobile-menu ${isMenuOpen ? "open" : ""}`}>
        <Button className="mobile-menu-item" onClick={toggleMenu}>
          CLOSE
        </Button>
        <Button className="mobile-menu-item">
        <a href="tel:+971544961587" className="mobile-menu-item">
          <div className="phone-button-content">
            <HiPhone />
            <span>+971 5 44961587</span>
          </div>
        </a>
        </Button>
        <Button className="mobile-menu-item">
          <Button onClick={onOpen}>REQUEST A CALLBACK</Button>
        </Button>
      </div>

      <div className="left-side">
        <div className="main-con-div">
          {!isFormVisible ? (
            <PostProjectButton onClick={handleButtonClick} />
          ) : (
            <DynamicForm
              formData={formData}
              activeForm={activeForm}
              setActiveForm={setActiveForm}
              completeForm={completeForm}
              onFormSubmit={handleFormSubmission}
              setFormVisible={setFormVisible}
              isFormVisible={isFormVisible}
              formSubmitted={formSubmitted}
              setFormSubmitted={setFormSubmitted}
            />
          )}
        </div>

        <div className="right-side">
          {!isFormVisible && !formSubmitted && (
            <div className="image-container">
              <img src={projectImage} alt="Project" className="project-image" />
            </div>
          )}
          {formSubmitted && (
            <div className="image-container">
              <img src={projectImage} alt="Project" className="project-image" />
            </div>
          )}
          {isFormVisible && !formSubmitted && (
            <FormNames
              formData={formData}
              activeForm={activeForm}
              completedForms={completedForms}
            />
          )}
        </div>
      </div>
      {formSubmitted && !isFormVisible && (
        <div className="user-data-container">
          <UserDataForm
            setFormSubmitted={setFormSubmitted} 
          />
        </div>
      )}

      <div
        className={`overlay ${isMenuOpen ? "open" : ""}`}
        onClick={toggleMenu}
      ></div>

      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          {!showThankYou && (
            <>
              <ModalHeader className="modalheader">
                REQUEST A CALLBACK
              </ModalHeader>
              <Text
                className="text head-text"
                as="kbd"
                colorScheme="yellow"
                textAlign="center"
                mb="4"
              >
                Have one of our experts call you for immediate assistance
              </Text>
            </>
          )}
          <ModalCloseButton />
          <ModalBody>
            {showThankYou ? (
              <Text
                color="#fdb702"
                textAlign="center"
                className="thankyou-text"
              >
                Thank you for your response! <br /> <br />
                One of our specialists will be in touch with you shortly for
                further assistance.
              </Text>
            ) : (
              <CallbackForm onFormSubmit={handleFormSubmit} />
            )}
          </ModalBody>
        </ModalContent>
      </Modal>
    </div>
  );
};

export default LandingPage;
